import React from "react";
import { Dialog as DialogMui } from "@mui/material";
import { DialogContent } from "@mui/material";
import { styled } from "@mui/material";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useWindowSize from "hook/useWindowSize";
import { DialogProps, DialogContentProps, SizeDialogType } from "context/Dialog/types";

export const convertWidth = (data: SizeDialogType) => {
  if (data) {
    if (data === "xs") {
      return 350;
    }
    if (data === "sm") {
      return 440;
    }
    if (data === "md") {
      return 600;
    }
    if (data === "lg") {
      return 980;
    }
    if (data === "xl") {
      return 1200;
    }
  }
};

const DialogContentContainer = styled(DialogContent)<DialogContentProps>`
  ${(props) => {
    if (props.size) {
      if (convertWidth(props.size) > props.screenwidth) {
        return;
      } else {
        return `width: ${convertWidth(props.size)}px !important;`;
      }
    }
  }}
  ${(props) => {
    if (props.screenwidth < 375) {
      return `width: auto !important;`;
    }
  }}
  ${(props) => props.theme.breakpoints.only("xs")} {
    width: 350px;
  }
  ${(props) => props.theme.breakpoints.only("sm")} {
    width: 440px;
  }
  ${(props) => props.theme.breakpoints.only("md")} {
    width: 440px;
  }
  ${(props) => props.theme.breakpoints.only("lg")} {
    width: 600px;
  }
  ${(props) => props.theme.breakpoints.only("xl")} {
    width: 600px;
  }
  background: #ffffff;
  box-shadow: 0px -8px 16px 0px #00000040 inset;
  border-radius: 20px;
  /* width: 440px; // ตาม ขนาดจอ */
  display: flex;
  justify-content: center;
  padding: 40px 24px;
  box-sizing: border-box;
  white-space: pre-wrap;
`;
const Close = styled(IconButton)`
  top: ${(props) => props.theme.spacing(0.5)};
  right: ${(props) => props.theme.spacing(0.5)};
  position: absolute;
`;

const Dialog: React.FC<DialogProps> = ({
  open,
  handleClose,
  children,
  size,
  isClose = true,
  ...props
}) => {
  return (
    <>
      <DialogMui
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={false}
        maxWidth={false}
        {...props}
        disableAutoFocus
        PaperProps={{
          style: { borderRadius: 20, margin: "12px" },
        }}
      >
        <Close aria-label="close" onClick={handleClose}>
          {isClose && <CloseIcon />}
        </Close>
        <DialogContentContainer size={size} screenwidth={useWindowSize()}>
          {children}
        </DialogContentContainer>
      </DialogMui>
    </>
  );
};

export default Dialog;
